import { render } from "./single-package-seating-chart.vue?vue&type=template&id=4e04570a"
import script from "./single-package-seating-chart.vue?vue&type=script&lang=js"
export * from "./single-package-seating-chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__